import { gql } from "graphql-tag"

import { DEFAULTS } from "@/graphql/schemas/shared/utils/defaults"

const typeTourSchedule = gql`
    type TourSchedule {
      id: ID
      year: Int
      calendarWeek: Int
      tours: [Int]
      creationAt: String
      modifiedAt: String
    }

    type TourSchedules {
      total: Int
      items: [TourSchedule]
    }

    type Query {
      tourSchedules(
        offset: Int = ${DEFAULTS.QUERY.OFFSET}
        limit: Int = ${DEFAULTS.QUERY.LIMIT}
        sort: Sort
        sortWithinLimits: Boolean = false
        lang: String = ""
        cdn: Boolean = true
      ): TourSchedules

      tourSchedule(id: ID!): TourSchedule
    }
`

export { typeTourSchedule }

export default typeTourSchedule
